<template>
    <v-footer
        class="footer"
        color="primary"
        padless
    >

        <div class="container">
            <v-row class="align-center"
                   no-gutters

            >
                <v-col cols="10">
                    <div class="copyright">Copyright © {{new Date().getFullYear()}} Outbrain Inc. All rights reserved. Teads is a trademark of Teads Holding Co.
                    </div>
                    <div class="d-flex flex-wrap footer-links">
                        <div :key="link.desc"
                             class="link"
                             v-for="link in links">
                            <a :href="link.ref">{{ link.desc }}</a>
                        </div>
                    </div>
                </v-col>
                <v-col cols="2">
                    <v-btn
                        v-for="item in icons"
                        :key="item.icon"
                        :href="item.url"
                        :aria-label="item.description"
                        class="ma-1"
                        dark
                        icon
                        target="_blank"
                    >
                        <v-icon size="24px">{{ item.icon }}</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </v-footer>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {mdiFacebook, mdiLinkedin, mdiTwitter, mdiYoutube} from '@mdi/js';

@Component({})
export default class Footer extends Vue {

    private links = [
        {
            desc: 'Interest-Based Ads (and Opt-Out Preferences)',
            ref: 'https://dsr.outbrain.com/recommendations-settings/home'
        },
        {desc: 'Advertising Guidelines', ref: 'https://www.outbrain.com/advertisers/guidelines/'},
        {desc: 'Privacy Policy', ref: 'https://www.outbrain.com/privacy'},
        {desc: 'Security', ref: 'https://www.outbrain.com/security'},
        {desc: 'Patents', ref: 'https://www.outbrain.com/patents/'},
        {desc: 'Terms of Use', ref: 'https://www.outbrain.com/legal#terms-of-use'},
    ];

    private icons = [
        {
            icon: mdiFacebook,
            url: 'https://www.facebook.com/OutbrainDirectResponse',
            description: 'Facebook',
        },
        {
            icon: mdiLinkedin,
            url: 'https://www.linkedin.com/showcase/outbrain-direct-response',
            description: 'Linkedin',

        }
    ]

    mounted() {
    }

}

</script>

<style scoped lang="scss">
.footer {
    .waves {
        bottom: 5px;
        position: relative;
        background-color: transparent;
        background-image: url("../assets/images/waves.svg");
        background-repeat: repeat-x;
        background-position: left center;
        width: 100%;
        height: 10px;
    }

    .copyright {
        font-size: 11px;
        color: white;
        font-weight: 100;
        margin-top: 6px;
        opacity: 0.5;
    }

    .footer-links {
        .link {
            padding: 5px;
            font-size: 14px;
        }

        a {
            color: white;
        }

    }


}
</style>
